export class Diet {
    code: number;    
    description: string;
}